<template>
  <div class="order-container">
    <el-card>
      <div slot="header">
        <span>课程录入</span>
      </div>
      <el-tabs value="first" type="border-card">
        <el-tab-pane label="单条录入" name="first">
          <el-form :model="singleForm" :rules="singleRules" ref="singleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="课程名称" prop="ccoursename">
              <el-input v-model="singleForm.ccoursename"></el-input>
            </el-form-item>
            <el-form-item label="课程类型" prop="type">
              <el-radio-group v-model="singleForm.type">
                <el-radio :label="0">专业课</el-radio>
                <el-radio :label="1">公共课</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('singleForm')">立即创建</el-button>
              <el-button @click="resetForm('singleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="批量录入" name="second">
          <el-form label-width="100px">
            <el-form-item label="数据格式">
              <div class="format-help">
                <p>请按照以下格式输入数据，每行一条课程信息：</p>
                <p><strong>课程名 课程类型</strong></p>
                <p>例如：</p>
                <p>2026考研数学 专业课</p>
                <p>2026考研英语 公共课</p>
                <p>2026考研政治 公共课</p>
              </div>
            </el-form-item>
            <el-form-item label="课程数据">
              <el-input
                v-model="batchText"
                type="textarea"
                :rows="10"
                placeholder="请按照格式输入课程数据，每行一条记录"
                style="width: 100%"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleBatchParse">解析数据</el-button>
              <el-button @click="parseBatchData">录入解析结果</el-button>
              <el-button @click="clearBatchData">清空</el-button>
            </el-form-item>
          </el-form>
          
          <!-- 解析结果预览 -->
          <div v-if="parsedData.length > 0" class="parsed-result">
            <h4>解析结果预览 ({{ parsedData.length }} 条记录)</h4>
            <el-table :data="parsedData" style="width: 100%" border>
              <el-table-column prop="ccoursename" label="课程名"></el-table-column>
              <el-table-column prop="type" label="课程类型">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.type === '0' ? 'primary' : 'success'">
                    {{ scope.row.type === '0' ? '专业课' : '公共课' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" @click="removeParsedItem(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="文件录入" name="third">
          
        </el-tab-pane> -->
      </el-tabs>
    </el-card>

  </div>
</template>

<script>
export default {
  name: 'Orders',
  data() {
    return {
      loading: false,
      singleForm: {
        ccoursename: '',
        type: 0
      },
      // 表单验证规则
      singleRules: {
        ccoursename: [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
        ]
      },
      // 批量录入相关
      batchText: '',
      parsedData: [],
      // 表单验证规则
      formRules: {
        ccoursename: [
          { required: true, message: '请输入课程名', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择课程类型', trigger: 'change' }
        ]
      }
    }
  },
  created() {},
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (!valid) return
        try {
          const {data: res}= await this.$http.post('create_course',  {
          courses: this.singleForm
        });
          if (res.code == 200){
            this.$message.success('课程创建成功')
            this.$refs[formName].resetFields();
          } else{
            this.$message.error('创建失败')
          }
        } catch (error) {
          this.$message.error('创建失败')
        }
      })
    },

    // 批量解析数据
    handleBatchParse() {
      if (!this.batchText.trim()) {
        this.$message.warning('请输入课程数据');
        return;
      }
      
      const lines = this.batchText.split('\n').filter(line => line.trim());
      const parsed = [];
      const errors = [];
      
      lines.forEach((line, index) => {
        const parts = line.split(' ').map(part => part.trim());
        
        if (parts.length !== 2) {
          errors.push(`第${index + 1}行格式错误: ${line}`);
          return;
        }
        
        const [ccoursename, typeStr] = parts;
        
        if (!ccoursename) {
          errors.push(`第${index + 1}行课程名为空: ${line}`);
          return;
        }
        
        // 转换课程类型
        let type;
        if (typeStr === '专业课') {
          type = 0;
        } else if (typeStr === '公共课') {
          type = 1;
        } else {
          errors.push(`第${index + 1}行课程类型错误: ${typeStr} (应为"专业课"或"公共课"): ${line}`);
          return;
        }
        
        parsed.push({
          ccoursename,
          type
        });
      });
      
      // 显示错误信息
      if (errors.length > 0) {
        this.$message.error(`解析发现 ${errors.length} 个错误：\n${errors.join('\n')}`);
      }
      
      this.parsedData = parsed;
      
      if (parsed.length > 0) {
        this.$message.success(`成功解析 ${parsed.length} 条课程数据`);
      }
    },
    
    // 录入解析结果
    async parseBatchData() {
      if (this.parsedData.length === 0) {
        this.$message.warning('请先解析数据');
        return;
      }
      
      try {
        // 这里替换为实际的批量API调用
        console.log('批量提交课程:', this.parsedData);
        const {data: res} = await this.$http.post('create_course', {
          courses: this.parsedData
        });
        if (res.code == 200){
          this.$message.success(`成功录入 ${this.parsedData.length} 条课程`);
          this.clearBatchData();
        } else {
          this.$message.error('批量录入失败' + res.errmsg);
        }
      } catch (error) {
        this.$message.error('批量录入失败');
        console.error('批量录入错误:', error);
      }
    },
    
    // 删除解析结果中的某一项
    removeParsedItem(index) {
      this.parsedData.splice(index, 1);
    },
    
    // 清空批量数据
    clearBatchData() {
      this.batchText = '';
      this.parsedData = [];
    }
  }
}
</script>

<style lang="less">
.order-container {
  padding: 20px;
}

.password_show {
  .el-input__inner {
    border: none;
    background-color: rgba(255, 255, 255, 0);
  }
}
</style>